import { render } from "./ProductImages.vue?vue&type=template&id=11d32184&scoped=true&ts=true"
import script from "./ProductImages.vue?vue&type=script&lang=ts"
export * from "./ProductImages.vue?vue&type=script&lang=ts"

import "./ProductImages.vue?vue&type=style&index=0&id=11d32184&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11d32184"]])

export default __exports__